export default __webpack_public_path__ + "static/media/impact-report.3394527b.png";